// src/frontend_react/src/components/navigation/UserSidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import Stack from '../ui/Stack/Stack';
import Box from '../ui/Box/Box';
import Icon from '../ui/Icon/Icon';
import Typography from '../ui/Typography/Typography';
import styles from './Sidebar.module.css';

import { FiGrid, FiUnlock, FiHome } from 'react-icons/fi'; 

const UserSidebar = () => {
  const navItems = [
    { to: "/user/dashboard", label: "Dashboard", icon: FiHome },
    { to: "/user/workspace", label: "Workspace", icon: FiGrid },
    { to: "/user/access-data", label: "Access & Decrypt", icon: FiUnlock },
  ];

  return (
    <Box as="aside" className={styles.sidebar}>
      <Stack spacing="md" p="md" style={{ height: '100%' }}>
        <Box className={styles.sidebarHeaderTitleContainer} p="md" mb="md">
          <Typography variant="h5" component="h2" fontWeight="semibold" color="primary-text" align="left">
            Data Operations
          </Typography>
        </Box>

        <Box as="nav" aria-label="User Navigation" flexGrow={1}>
          <Stack as="ul" spacing="xs" className={styles.navList}>
            {navItems.map(item => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
                  title={item.label}
                  end={item.to === "/user/dashboard"}
                >
                  {item.icon && <Icon as={item.icon} className={styles.navIcon} size="lg" />}
                  <Typography variant="body1" component="span" className={styles.navLabel}>
                    {item.label}
                  </Typography>
                </NavLink>
              </li>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default UserSidebar;